export const ProcessEN = {
    "document": "Document",
    "managementByMe": "Management By Me",
    "newFolder": "New Folder",
    "process": "Process",
    "workProcess": "Work Process",
    "all": "All",
    "processTemplate": "Process Template",
    "performanceForMe": "Performance For Me",
    "assignedByMe": "Assigned By Me",
    "followedByMe": "Followed By Me",
    "assignedByDepartment": "Assigned By Department",
    "assignedByPosition": "Assigned By Position",
    "expectedTask": "Expected Task",
    "dynamicForm": "Dynamic Form",
    "processConfig": "Process Config",
    "salaryAdvanceApplication": "Salary Advance Application",
    "reportForm": "Report Form",
    "work" : "Work",
    "allProcess": "All",
    "myProcess": "Performed by me",
    "departmentProcess": "My department",
    "positionProcess": "My position",

}